import type { FilterSection } from "@/types/filterTypes";

import { useApplicationStatuses } from "@/lib/api/hooks/application";
import countryOptions from "@/utils/constants/countriesOptions";

export const useApplicationsFilterSections = (): FilterSection[] => {


  const {data } = useApplicationStatuses();
const applicationStatuses = data?.data ? data.data.map((status: { displayName: string; value: string; }) => ({
    label: status.displayName,
    value: status.value
  })) : [];

  return [
    {
      key: "status",
      label: "Status",
      type: "select",
      options: applicationStatuses
    },
    {
      key: "country",
      label: "Country",
      type: "select",
      options: countryOptions.map((country) => ({
        label: country.label,
        value: country.label
      }))
    },
      {
      key: "searchBy",
      label: "Search",
      type: "text",
      placeholder: "Search by name, email, phone, or country"
    },
    {
      key: "jobId",
      label: "Job ID",
      type: "text",
      placeholder: "Enter Job ID"
    },
    {
      key: "startDate",
      label: "Start Date",
      type: "date",
      placeholder: "From"
    },
    {
      key: "endDate",
      label: "End Date",
      type: "date",
      placeholder: "To"
    }
  ];
};
